import MDBox from "components/MDBox";
import { SelectEmployee } from "components/SelectEmployee";
import DataTable from "examples/Tables/DataTable";
import moment from "moment";
import { useEffect, useState } from "react";
import ApiCalls from "services/flick_erp_api_call";
import { TextField } from "@mui/material";

export function LeaveBalanceComponent({reload, leaveAdmin, adminFilters}) {
    const [selectedEmployee, setSelectedEmployee] = useState(null);
    const [selectedManager, setSelectedManager] = useState(null);
    const [selectedMonth, setSelectedMonth] = useState(moment().format("YYYY-MM"));
    const effectiveEmployee = adminFilters?.employee || selectedEmployee;
    const effectiveManager = adminFilters?.manager || selectedManager;
    const effectiveMonth = adminFilters?.month || selectedMonth;

    useEffect(() => {
        getLeaveBalances();
      }, [reload, selectedEmployee, selectedManager, selectedMonth, leaveAdmin, adminFilters]);
      const user_id = JSON.parse(localStorage.getItem("user")).employee_id;
    const [employee, setEmployee] = useState({});
    async function getLeaveBalances() {
      if (leaveAdmin) {
        const params = new URLSearchParams();
        if (effectiveEmployee) {
          params.append("employee", effectiveEmployee);
        }
        if (effectiveManager) {
          params.append("manager", effectiveManager);
        }
        if (effectiveMonth) {
          const [year, month] = effectiveMonth.split("-");
          params.append("year", year);
          params.append("month", month);
        }
        var res = await ApiCalls.getLeaveBalance(params.toString() ? `?${params.toString()}` : undefined);
        if (res.success && res.code == 200) {
          leaveBalanceData.rows = res.data;
          setLeaveBalanceData({ ...leaveBalanceData });
        }
        return;
      }

        var res = await ApiCalls.getEmployee(user_id);
        if (res.success && res.code == 200) {
          setEmployee(res.data);
        //   setLeaveBalance(res.data.leave_balances);
          leaveBalanceData.rows = res.data.leave_balances;
          setLeaveBalanceData({ ...leaveBalanceData });
        } else {
        }
      }
    const [leaveBalanceData, setLeaveBalanceData] = useState({
        columns: [
          {
            Header: "Employee",
            accessor: "employee_name",
            Cell: ({ row }) => (
              <div style={{ display: "flex", alignItems: "center" }}>
                {row.original?.employee?.user?.firstname} {row.original?.employee?.user?.lastname}
              </div>
            ),
          },
          {
            Header: "Added Date",
            accessor: "created_at",
            Cell: ({ row }) => (
              <div style={{ display: "flex", alignItems: "center" }}>
                {moment(row.original.created_at).format("YYYY-MM-DD")}
              </div>
            ),
          },
          {
            Header: "Leave Type",
            accessor: "leave",
            Cell: ({ row }) => (
              <div style={{ display: "flex", alignItems: "center" }}>
                {row.original.leave_type.name}
              </div>
            ),
          },
          { Header: "Balance", accessor: "balance" },
          {
            Header: "Allowed hours",
            accessor: "allowed_hours",
            Cell: ({ row }) => (
              <div style={{ display: "flex", alignItems: "center" }}>
                {row.original.leave_type.max_hours_allowed}
              </div>
            ),
          },
          // { Header: "Leave Remark", accessor: "leave_remark" },
          // { Header: "Hours", accessor: "hours" },
          // { Header: "Note", accessor: "note" },
        ],
        rows: [],
      });
    return (
      <MDBox>
        {leaveAdmin && !adminFilters && (
          <MDBox display="flex" alignItems="center" justifyContent="flex-end" mb={2}>
            <SelectEmployee
              label="Employee"
              placeholder="Filter employee"
              onSelected={setSelectedEmployee}
            />
            <MDBox mr={2} />
            <SelectEmployee
              label="Manager"
              placeholder="Filter manager"
              onSelected={setSelectedManager}
            />
            <TextField
              type="month"
              label="Month"
              value={selectedMonth}
              onChange={(event) => setSelectedMonth(event.target.value)}
              InputLabelProps={{ shrink: true }}
              sx={{ width: 180, ml: 2 }}
            />
          </MDBox>
        )}
         <DataTable table={leaveBalanceData}></DataTable></MDBox>
     );
}
